import React from 'react';
import SegmentedControl from './SegmentedControl';
import SwitchRow from './SwitchRow';
import { choice } from './choiceStyles';
import { CONTAINER_SIZES } from '../../../utils/truckCatalog';

// Bortkjøring med container: bryter og størrelse. Container krever krokløftbil.
export default function ContainerPicker({ value, onChange }) {
  return (
    <div style={{ ...choice.card, padding: '4px 14px 12px' }}>
      <SwitchRow
        title="Bruk container" sub="Container settes ut og hentes av krokløftbil"
        checked={value.on} onChange={on => onChange({ on, size: on ? value.size : null })}
      />
      {value.on && (
        <>
          <div style={choice.divider} />
          <span style={choice.label}>Størrelse</span>
          <SegmentedControl
            ariaLabel="Containerstørrelse" fill value={value.size}
            options={CONTAINER_SIZES.map(s => ({ value: s, label: `${s} m³` }))}
            onChange={size => onChange({ on: true, size })}
          />
          <div style={choice.hint}>Krever krokløftbil</div>
        </>
      )}
    </div>
  );
}
